import { Link } from "react-router-dom";
import React from "react";
import PageSeo from "../../components/seo/PageSeo";
import { useTranslation } from "react-i18next";
import "./thanks.css";

/* PAIEMENT ÉCHOUÉ — design "Signal" */
const Error = () => {
  const { t } = useTranslation();
  return (
    <div className="sg-page" style={{ maxWidth: 520, minHeight: "60vh", justifyContent: "center" }}>
      <PageSeo noindex title={t("signal.pay-failed-title")} />
      <div className="sg-panel" style={{ padding: 32, textAlign: "center" }}>
        <span
          style={{
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            width: 52, height: 52, borderRadius: "50%",
            background: "var(--color-danger-soft)", color: "var(--color-danger)",
            font: "700 24px/1 var(--font-display)", marginBottom: 14,
          }}
        >
          ✕
        </span>
        <h1 className="sg-h1" style={{ fontSize: 22, marginBottom: 8 }}>{t("signal.pay-failed-title")}</h1>
        <p className="sg-sub" style={{ fontSize: 14, marginBottom: 20 }}>
          {t("signal.pay-failed-body")}
        </p>
        <Link to="/deposit" className="sg-btn sg-btn--primary">{t("signal.pay-failed-retry")}</Link>
      </div>
    </div>
  );
};

export default Error;
